/* eslint-disable react-refresh/only-export-components */
import React, { useState, useEffect, /* useContext, */ useCallback, useContext } from 'react';
import Api from '../../apis/meshApi';
import { Project } from '../../Models/Project';
import MikeTable from '../../components/mike-table';
import { GlobalContext } from '../../store/Store';
import  ActionType from '../../store/ActionType';
/* import FolderCreateForm from './FolderCreateForm';
import MikeSlidingPanel from '../../components/mike-sliding-panel'; */
import Projects from '../../icons/Projects.svg?react';
import { useNavigate, useParams } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';


export const columns = [
  {
    id: 'name',
    type: 'link',
    label: 'Project name',
    sortable: true,
    render(_row: any, value: React.ReactNode) {
      return (
        <>
          <span>
            <Projects />
          </span>
          <span
            style={{
              cursor: 'pointer',
              display: 'block',
              marginTop: '12px',
              maxWidth: '80%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            <Tooltip title={value}>
              <>{value}</>
            </Tooltip>
          </span>
        </>
      );
    },
    filtrable: true,
  },
  {
    id: 'description',
    label: 'Description',
    sortable: true,
    render(_row: any, value: React.ReactNode) {
      return (
        <div
          style={{
            display: 'table-cell',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '90%',
          }}>
          <Tooltip title={value}>
            <>{value}</>
          </Tooltip>
        </div>
      );
    },
    filtrable: true,
  },
  { id: 'accessRights', label: 'Access rights' },
  {
    id: 'createdAt',
    label: 'Created',
    sortable: true,
    type: 'date',
    showTime: true,
  },
  {
    id: 'updatedAt',
    label: 'Edited',
    sortable: true,
    type: 'date',
    showTime: 'true',
  },
];

const config = {
  filtered: true,
  pagination: true,
  addButton: false,
  startButton: true, 
  defaultSort: { field: 'updatedAt', dir: 'desc', type: 'date' },
};

interface Props {
  onProjectSelectedCallback?: () => void; 
}

function FolderList({ onProjectSelectedCallback }: Props) {
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const isProjectContributor = globalState.project && globalState.project.currentProject && globalState.project.currentProject.canEdit ? globalState.project.currentProject.canEdit : false;
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
/*   const [isPanelOpen, setOpenPanel] = useState(false);
  const [isAddingProject, setIsAddingProject] = useState(false); */
  // global store

  const [formattedProjects, setFormattedProjects] = React.useState(data);

  useEffect(() => {
    const _projects = data.map((project: any) => {
      const canWrite = project.canEdit;
      const canRead = project.canRead;
      let accessRight;
      if (canWrite) {
        accessRight = 'Write';
      } else if (!canWrite && canRead) {
        accessRight = 'Read';
      } else {
        accessRight = 'N/A';
      }
      project.accessRights = accessRight;
      project.description = project.description !== null ? project.description : '';
      return project;
    });
    setFormattedProjects(_projects as any);
  }, [data]);



  function onNavigateToFolder(selectedProject: Project) {
    if (selectedProject && selectedProject.name) {     
      navigate('/project/' + selectedProject.id);
      onProjectSelectedCallback();
    }
  }

  const onNavigateToMap = useCallback(() => {
    if (id) {   
      navigate('/map?projectID=' + id);
      onProjectSelectedCallback();
    }
  }, [id, navigate, onProjectSelectedCallback])

  useEffect(() => {
    
    async function fetchProjectAndPath(id: string) {
      try {
        const projectResponse = await Api.getProject(id);
        const pathResponse = await Api.getProjectPath(id);
        if (projectResponse && projectResponse.data) {
          globalDispatch({
            type: ActionType.SET_CURRENT_PROJECT_AND_PATH,
            data: {
              project: projectResponse.data,
              path: pathResponse && pathResponse.data ? pathResponse.data : [],
            },
          });
        }
      } catch (e) {
        console.log(e.message || 'Unexpected error');
      }
    }
    const getProjectAndPath = async () => {
      await fetchProjectAndPath(id);
    };
    async function fetchProjects(projectId: string) {
      try {    
        const response = await Api.getSubProjects(projectId);
        setData(response.data);
      } catch (e) {
        setError(e.message || 'Unexpected error');
      }
      setLoading(false);
    }
    if (id){
      fetchProjects(id);
      getProjectAndPath();
    } 
  }, [id]);

  if (error) {
    return <div style={{ color: 'red' }}>ERROR: {error}</div>;
  }

  return (
   /*  <>
      <MikeSlidingPanel
        isOpen={isPanelOpen}
        onClose={() => {
          setOpenPanel(false);
        }}
        titleArea={'Create a new folder'}
        position="right"
        contentArea={<FolderCreateForm onAdd={addProject} isAddingProject={isAddingProject} />}
        actionsArea={null}
        noGrayOverlay={false}
      /> */

      <MikeTable
        loading={loading}
        onSelect={onNavigateToFolder}
        rows={formattedProjects}
        config={config}
        columns={columns}
        maxHeight={'65vh'}
/*         onAdd={() => {
          setOpenPanel(true);
        }} */
        onStart={onNavigateToMap}
        canEditFolder={isProjectContributor}
        title={'Folders'}
        addButtonText={'Add folder'}
        startButtonText={'Start extraction'}
      />
    // </>
  );
}

export default FolderList;
